import React, { useEffect, useState } from "react";
import Access from "../Access/Access";
import Banner from "../Banner/Banner";
import NewListing from "../NewListing/NewListing";
import Offer from "../Offer/Offer";
import SaveMoreMsg from "../SaveMoreMsg/SaveMoreMsg";
import Footer from "../Shard/Footer";
import ShareAndFind from "../ShareAndFind/ShareAndFind";
import Testimonial from "../Testimonial/Testimonial";
import OfferBg from "../Offer/OfferBg";
import NavbarMenu from "../Shard/NavbarMenu";
import Host from "../Host/Host";

function useWindowSize() {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);
  useEffect(() => {
    const hanleResize = () => {
      setSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", hanleResize);
    return () => {
      window.removeEventListener("resize", hanleResize);
    };
  }, []);
  return size;
}
const Home = () => {
  return (
    <div>
      <NavbarMenu />
      <Banner useWindowSize={useWindowSize} />
      <ShareAndFind />
      <SaveMoreMsg />
      <NewListing />
      <OfferBg />
      <Offer />
      <Host />
      <Testimonial />
      <Access useWindowSize={useWindowSize} />
      <Footer />
    </div>
  );
};

export default Home;
